export const DEBUG = false;